import { render } from "./navSection.vue?vue&type=template&id=4a956d18&scoped=true&ts=true"
import script from "./navSection.vue?vue&type=script&lang=ts"
export * from "./navSection.vue?vue&type=script&lang=ts"

import "./navSection.vue?vue&type=style&index=0&id=4a956d18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a956d18"]])

export default __exports__